export default "__VITE_PUBLIC_ASSET__179527b3__"